// extracted by mini-css-extract-plugin
module.exports = {"title":"CmdtsFactors_title__vuMM4"};